import { Box, Modal, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface whenModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const outerStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  borderRadius: 2,
  width: { xs: "87vw", sm: "80vw" },
  maxWidth: 600,
  maxHeight: "75vh",
  display: "flex",
  flexDirection: "column",
  overflow: "visible", 
};

const contentStyle = {
  overflowY: "auto", 
  flex: "1 1 auto", 
  minHeight: 0,
  pr: 0,
  pl: 0,
};


const ItineraryItem = ({ text, time }: { text: string; time: string }) => (
  <Box
    sx={{
      width: "100%",
      maxWidth: 450,
      display: "grid",
      gridTemplateColumns: { xs: "150px 1fr", sm: "220px 1fr" }, 
      rowGap: { xs: 0.5, sm: 0 },
      columnGap: { sm: 2 },
      alignItems: "center",
      py: 0.5,
      textAlign: { xs: "center", sm: "inherit" },
    }}
  >
    <Typography
      variant="body1"
      sx={{
        fontSize: { xs: "1rem", sm: "1.1rem" },
        fontWeight: 500,
        whiteSpace: { xs: "normal", sm: "nowrap" }, 
      }}
    >
      {text}
    </Typography>

    <Typography
      variant="body1"
      sx={{
        fontSize: { xs: "1rem", sm: "1.1rem" },
        whiteSpace: "nowrap",
      }}
    >
      {time}
    </Typography>
  </Box>
);


const WhenModal = ({ isOpen, handleClose }: whenModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="where-modal-title"
      aria-describedby="where-modal-description"
    >
      <Box sx={outerStyle}>
        <IconButton
          onClick={handleClose}
          aria-label="close"
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            color: "text.secondary",
            backgroundColor: "rgba(255,255,255,0.85)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,1)",
            },
            zIndex: 10,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography
          id="where-modal-title"
          variant="h4"
          fontWeight="bold"
          gutterBottom
          align="center"
        >
          Itinerary
        </Typography>

        <Box sx={contentStyle}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            flex: 1,
            padding: "0rem 2rem",
          }}
        >

          <ItineraryItem text="Guests Arrive" time="1:00pm" />
          <ItineraryItem text="Ceremony" time="1:30pm - 2:00pm" />
          <ItineraryItem text="Drinks Reception" time="2:15pm - 3:45pm" />
          <ItineraryItem text="Seat Guests"  time="3:45pm - 4:30pm"/>
          <ItineraryItem text="Speeches" time="4:30pm - 5:00pm" />
          <ItineraryItem text="Meal"  time="5:00pm - 7:00pm"/>
          <ItineraryItem text="First Dance"  time="8:00pm"/>
          <ItineraryItem text="Buffet"  time="9:30pm"/>
          <ItineraryItem text="Home time"  time="1:00am"/>
          </div>

        </Box>
      </Box>
    </Modal>
  );
};

export default WhenModal;
